<template>
	<div class="search-adverts">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['adverts:insert']"
					icon="el-icon-plus"
					@click="addAdverts"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="adverts"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="userName">
						<el-input
							v-model="search.userName"
							:placeholder="$t('searchAdverts.userName')"
						></el-input>
					</el-form-item>
					<el-form-item prop="head">
						<el-input
							v-model="search.head"
							:placeholder="$t('searchAdverts.title')"
						></el-input>
					</el-form-item>
					<el-form-item prop="nickName">
						<el-input
							v-model="search.nickName"
							:placeholder="$t('searchAdverts.nickName')"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button @click="resetSearch('adverts')" icon="el-icon-refresh">{{
							$t("common.reset")
						}}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchAdverts",
	props: {
		search: Object,
	},
	methods: {
		addAdverts() {
			this.$emit("addAdverts");
		},
		onSubmit() {
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
	},
};
</script>

<style lang="scss"></style>
